import { Component, OnDestroy, OnInit } from '@angular/core';
import { LandingService } from '../../services/landing.service';
import { IProduct } from '../../../shared/interfaces/IProduct';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sale-product-page',
  templateUrl: './sale-product-page.component.html',
  styleUrls: ['./sale-product-page.component.scss'],
})
export class SaleProductPageComponent implements OnInit, OnDestroy {
  products: IProduct[] = [];
  viewProducts: IProduct[] = [];
  productsForSale: any[] = [];
  lastProductIndex = 0;
  firstProductIndex = 0;
  destroy$: Subject<any>;
  zip_code: any;
  loading = false;
  constructor(
    private landingService: LandingService,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.destroy$ = new Subject<any>();
  }
  isDateInRange: boolean = false;
  ngOnInit(): void {
    // CYBERFIL 2024
    const today = new Date(); // Fecha actual
    const startDate = new Date('2024-11-01T00:00:00-03:00'); // Fecha de inicio
    const endDate = new Date(2024, 10, 15, 23, 59, 59, 999); // 15 de noviembre

    // Asegúrate de que las comparaciones se hagan en la misma zona horaria
    this.isDateInRange = today >= startDate && today <= endDate;

    // Para depurar
    console.log('Fecha hoy:', today);
    console.log('Fecha de inicio:', startDate);
    console.log('Fecha de fin:', endDate);
    console.log('¿Está en el rango?', this.isDateInRange);
    // END CYBERFIL 2024

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        if (params.zipCode) {
          this.zip_code = params.zipCode;
        }
        if (params.disc) {
          if (params.disc == 'CYBERFIL50' || params.disc == 'CYBERFIL20') {
            this.discount = params.disc;
          }
        }
        this.products = [];
        this.loading = true;
        this.landingService
          .getProducts(this.zip_code)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            this.products = res.map((item) => {
              item.imageUrl = item.galeries?.[0]?.file_name;
              return item;
            });
            // CORREGIR 3:3 en version final
            var cantProducts = window.innerWidth <= 767 ? 4 : 4;
            this.lastProductIndex =
              this.products.length >= cantProducts
                ? cantProducts
                : this.products.length;
            this.firstProductIndex = this.lastProductIndex;
            this.nextProducts();
            this.products.forEach((product) => {
              if (product.periodicity && product.periodicity.length > 0) {
                const hasVenta = product.periodicity.find(
                  (p) => p.years === 0 && p.months === 0 && p.days === 0
                );

                if (hasVenta) {
                  this.productsForSale.push(product);
                }
              }
            });
            this.loading = false;
            this.gotoTop();
          });
      });
      console.log('this.productsForSale',this.productsForSale);
  }
  nextProducts(): void {
    // CORREGIR 3:3 en version final
    var cantProducts = window.innerWidth <= 767 ? 4 : 4;
    if (this.lastProductIndex === 0) {
      this.lastProductIndex =
        this.products.length >= cantProducts
          ? cantProducts
          : this.products.length;
    } else {
      this.firstProductIndex = this.lastProductIndex;
      this.lastProductIndex =
        this.products.length >= this.lastProductIndex + cantProducts
          ? this.lastProductIndex + cantProducts
          : this.products.length;
      if (this.firstProductIndex === this.lastProductIndex) {
        this.firstProductIndex = 0;
        this.lastProductIndex = 0;
        this.nextProducts();
      }
    }
    this.viewProducts = this.products.slice(
      this.firstProductIndex,
      this.lastProductIndex
    );
  }
  prevProducts(): void {
    var cantProducts = window.innerWidth <= 767 ? 1 : 4;
    if (this.firstProductIndex === 0) {
      this.lastProductIndex = this.products.length;
      this.firstProductIndex =
        this.products.length >= cantProducts
          ? this.lastProductIndex - cantProducts
          : 0;
    } else {
      this.lastProductIndex = this.firstProductIndex;
      this.firstProductIndex =
        this.products.length >= this.firstProductIndex - cantProducts
          ? this.firstProductIndex - cantProducts < 0
            ? 0
            : this.firstProductIndex - cantProducts
          : 0;
    }
    this.viewProducts = this.products.slice(
      this.firstProductIndex,
      this.lastProductIndex
    );
  }
  formatNumber(numeroOriginal: string): string {
    // Convierte el número de cadena a número de punto flotante (float)
    const numero = parseFloat(numeroOriginal);

    // Aplica el formato con tres decimales y usa '.' como separador de miles
    const numeroFormateado = numero.toLocaleString('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return numeroFormateado;
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  discount = '';
  getPrice(product: IProduct): {
    original_price: number;
    price: number;
    periodicity: string;
    original_cost: number;
    cost: number;
    periodicity_label: string;
    percentage: number;
  } | null {
    if (!product.periodicity || product.periodicity.length === 0) {
      return null;
    }

    const monthly = product.periodicity.find((item) => item.months >= 1);
    const discount = this.discount;

    if (monthly) {
      let price = monthly.pivot.periodic_price; // Precio original
      let cost;
      let periodicity_label;
      let percentage;
      // Aplicar descuento si corresponde
      if (discount === 'CYBERFIL50') {
        price = price * 0.5; // Aplicar 50% de descuento
        cost = 0;
        periodicity_label = 'en tu primer mes';
        percentage = 50;
      } else if (discount === 'CYBERFIL20') {
        price = price * 0.8;
        cost = 0;
        periodicity_label = 'en tus primeros 3 meses';
        percentage = 20;
      }

      if (monthly.months === 1) {
        return {
          original_price: monthly.pivot.periodic_price,
          price: price,
          cost: cost,
          original_cost: monthly.pivot.price,
          periodicity: ' x mes',
          periodicity_label: periodicity_label,
          percentage: percentage,
        };
      } else {
        switch (monthly.months) {
          case 2: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por bimestre',
              periodicity_label: '',
              percentage: percentage,
            };
          }
          case 3: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por trimestre',
              periodicity_label: '',
              percentage: percentage,
            };
          }
          case 4: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por cuatrimestre',
              periodicity_label: '',
              percentage: percentage,
            };
          }
          case 6: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: 'por semestre',
              periodicity_label: '',
              percentage: percentage,
            };
          }
          default: {
            return {
              original_price: monthly.pivot.periodic_price,
              price: price,
              cost: cost,
              original_cost: monthly.pivot.price,
              periodicity: `por ${monthly.months} meses`,
              periodicity_label: '',
              percentage: percentage,
            };
          }
        }
      }
    }

    const sale = product.periodicity.find(
      (item) => item.months === 0 && item.years === 0 && item.days === 0
    );
    if (sale) {
      let price = sale.pivot.periodic_price; // Precio original para la venta única
      let cost;
      // Aplicar descuento si corresponde
      if (discount === 'CYBERFIL50') {
        price = price * 0.5; // Aplicar 50% de descuento
        cost = 0;
      } else if (discount === 'CYBERFIL20') {
        price = price * 0.8;
        cost = 0;
      }

      return {
        original_price: sale.pivot.periodic_price,
        price: price,
        original_cost: sale.pivot.price,
        cost: 0,
        periodicity: `por única vez`,
        periodicity_label: '',
        percentage: 0,
      };
    }

    return null; // Si no se encuentra ninguna periodicidad
  }

  getSalePrice(
    product: IProduct,
    periodicityMonths: number
  ): {
    price: number;
    cost: number;
    percentage: number;
  } | null {
    if (!product.periodicity || product.periodicity.length === 0) {
      return null;
    }

    const periodicity = product.periodicity.find(
      (p: any) => p.months === periodicityMonths
    );
    if (periodicity) {
      return {
        price: periodicity.pivot.periodic_price,
        cost: periodicity.pivot.price,
        percentage: 40
      };
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  productDetail(product: IProduct, type: 'sale' | 'sub' = 'sub'): void {
    this.loading = true;
    let params = '?';
    if (this.zip_code) {
      params = 'zipCode=' + this.zip_code;
    }
    if (this.discount) {
      params += '&disc=' + this.discount;
    }
    // Add the purchase type parameter
    params += `&type=${type}`;
    this.router.navigateByUrl(`/products/${product.id}${params}`);
  }
}
